<template>
    <solid-box title="集体资源性资产">
        <div class="flex" style="padding: 0 25px">
            <div
                ref="container1"
                class="container"
                style="width: 450px; height: 215px;"
                v-auto-size
            />
            <div
                ref="container2"
                class="container"
                style="width: 450px; height: 215px;"
                v-auto-size
            />
            <div
                ref="container3"
                class="container"
                style="width: 450px; height: 215px;"
                v-auto-size
            />
        </div>
    </solid-box>
</template>

<script>
import SolidBox from '@/components/SolidBox'
import { getRelativelySize } from '@/utils/size'
import eventHub from '@/utils/eventHub'

/**
 * 集体资源性资产
 */
export default {
    components: {
        SolidBox
    },
    dataInfo: null,
    data() {
        return {
            tradeSum: {
                jtzyxzc: {
                    area: 0,
                    publishArea: 0,
                    transferArea: 0
                }
            }
        }
    },
    destroyed() {
        if (this.echartsInstance1) {
            this.echartsInstance1.dispose()
        }
        if (this.echartsInstance2) {
            this.echartsInstance2.dispose()
        }
        if (this.echartsInstance3) {
            this.echartsInstance3.dispose()
        }
        eventHub.$off('tradeChange')
    },
    mounted() {
        eventHub.$on('tradeChange', (tradeSum) => {
            this.tradeSum = tradeSum
            this.init()
        })
    },
    methods: {
        init() {
            if (this.echartsInstance1) {
                this.echartsInstance1.dispose()
            }
            if (this.echartsInstance2) {
                this.echartsInstance2.dispose()
            }
            if (this.echartsInstance3) {
                this.echartsInstance3.dispose()
            }
            const charInstance1 = echarts.init(this.$refs['container1'])
            const charInstance2 = echarts.init(this.$refs['container2'])
            const charInstance3 = echarts.init(this.$refs['container3'])
            this.echartsInstance1 = charInstance1
            this.echartsInstance2 = charInstance2
            this.echartsInstance3 = charInstance3
            this.setEchartOption()
        },
        delStr(str, num) {
            if (Number(str)) {
                return Number(str).toFixed(num)
            } else {
                return str ? Number(str.replace(/,/g, '')).toFixed(num) : ''
            }
        },
        setEchartOption() {
            this.echartsInstance1.setOption(
                this.getOptions(
                    '总面积(亩)',
                    this.delStr(this.tradeSum.jtzyxzc.area) || 0.0,
                    0.6
                ),
                {
                    notMerge: true
                }
            )
            this.echartsInstance2.setOption(
                this.getOptions(
                    '总挂网(亩)',
                    this.delStr(this.tradeSum.jtzyxzc.publishArea, 2) || 0,
                    0.3
                ),
                {
                    notMerge: true
                }
            )
            this.echartsInstance3.setOption(
                this.getOptions(
                    '总成交(亩)',
                    this.delStr(this.tradeSum.jtzyxzc.transferArea) || 0.0,
                    0.48
                ),
                {
                    notMerge: true
                }
            )
        },
        getOptions(text, textVal, value) {
            var data = [value, value, value]
            return {
                backgroundColor: echarts.graphic.RadialGradient(0.3, 0.3, 0.8, [
                    {
                        offset: 0,
                        color: '#282c51'
                    },
                    {
                        offset: 1,
                        color: '#050a2a'
                    }
                ]),
                title: {
                    text, // 文字描述
                    textStyle: {
                        fontSize: getRelativelySize(16),
                        fontFamily: 'Microsoft Yahei',
                        fontWeight: 'normal',
                        color: '#fff'
                    },
                    x: 'center',
                    y: '86%'
                },
                graphic: [
                    {
                        type: 'group',
                        left: 'center',
                        top: '65%',
                        children: [
                            {
                                type: 'text',
                                z: 100,
                                left: '10',
                                top: 'middle',
                                style: {
                                    fill: '#fff',
                                    text: textVal, // 数值
                                    fontFamily: 'Microsoft YaHei',
                                    fontSize: getRelativelySize(16)
                                }
                            }
                        ]
                    }
                ],
                series: [
                    {
                        type: 'liquidFill',
                        radius: '80%',
                        center: ['50%', '50%'],
                        data: data,
                        backgroundStyle: {
                            color: {
                                type: 'radial',
                                x: 0.5,
                                y: 0.5,
                                r: 0.7,
                                colorStops: [
                                    {
                                        offset: 1,
                                        color: 'rgba(50, 65, 96, 1)'
                                    },
                                    {
                                        offset: 0.5,
                                        color: 'rgba(50, 65, 96, 1)'
                                    },
                                    {
                                        offset: 0,
                                        color: 'rgba(111, 117, 139, 1)'
                                    }
                                ],
                                globalCoord: false
                            },
                            opacity: 0
                        },
                        outline: {
                            borderDistance: 0,
                            itemStyle: {
                                borderWidth: 0,
                                borderColor: {
                                    type: 'linear',
                                    x: 1,
                                    y: 0,
                                    x2: 0,
                                    y2: 0,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: 'rgba(212, 252, 125, 0)'
                                        },
                                        {
                                            offset: 0.5,
                                            color: 'rgba(2, 193, 131, 0)'
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(2, 193, 131, 0)'
                                        }
                                    ],
                                    globalCoord: false
                                },
                                shadowBlur: 10,
                                shadowColor: 'rgba(13, 13, 46, 0)'
                            }
                        },
                        color: new echarts.graphic.RadialGradient(0.6, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(178, 251, 105, 0)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(10, 203, 135, 0)'
                            }
                        ]),
                        label: {
                            normal: {
                                formatter: ''
                            }
                        }
                    },
                    {
                        type: 'liquidFill',
                        radius: '80%',
                        center: ['50%', '50%'],
                        //  shape: 'roundRect',
                        data: data,
                        backgroundStyle: {
                            opacity: 0
                        },
                        outline: {
                            borderDistance: getRelativelySize(5), // 内容到边框的距离
                            itemStyle: {
                                borderWidth: getRelativelySize(2), // 设置边框宽度
                                borderColor: {
                                    type: 'linear',
                                    x: 1,
                                    y: 0,
                                    x2: 0,
                                    y2: 0,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: 'rgba(212, 252, 125, 1)'
                                        },
                                        {
                                            offset: 0.5,
                                            color: 'rgba(2, 193, 131, 1)'
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(2, 193, 131, 1)'
                                        }
                                    ],
                                    globalCoord: false
                                },
                                shadowBlur: 10,
                                shadowColor: 'rgba(13, 13, 46, 1)'
                            }
                        },
                        color: new echarts.graphic.RadialGradient(0.6, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(178, 251, 105, 1)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(10, 203, 135, 1)'
                            }
                        ]),
                        label: {
                            normal: {
                                formatter: ''
                            }
                        }
                    }
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    position: relative;
    margin: 17px auto 0;
    width: 450px !important;
    height: 215px !important;
}
</style>
